"use strict";
/* tslint:disable:max-classes-per-file */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var element_1 = require("../decorators/element");
/**
 * Define custom element with providing the dependencies to constructor.
 * @param window window reference where custom element will be registered
 * @param selector selector of custom element
 * @param constructor constructor of custom element
 * @param deps dependencies list
 */
function define(window, selector, constructor, deps) {
    if (!deps || (Array.isArray(deps) && deps.length === 0)) {
        // doesnt support options - 2nd argument - for now
        element_1.element(selector, undefined, window)(constructor);
    }
    else {
        var valuesDeps_1 = Array.isArray(deps) ? deps : (deps());
        // doesnt support options - 2nd argument- for now
        element_1.element(selector, undefined, window)(/** @class */ (function (_super) {
            tslib_1.__extends(class_1, _super);
            function class_1( /* istanbul ignore next */) {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return _super.apply(this, valuesDeps_1) || this;
            }
            return class_1;
        }(constructor)));
    }
}
exports.define = define;
